<script setup lang="ts">
import type { FilterChip } from '@/types/browser';

defineProps<{
  chips: FilterChip[];
}>();

const emit = defineEmits<{
  removeChip: [chip: FilterChip];
}>();

const onRemove = (chip: FilterChip) => emit('removeChip', chip);
</script>

<template>
  <span
    v-for="chip in chips"
    :key="chip.key"
    class="filter-chip"
  >
    <span class="filter-chip-label">{{ chip.label }}</span>
    <button
      v-if="chip.removable !== false"
      type="button"
      class="filter-chip-remove"
      :aria-label="`Remove ${chip.label}`"
      @click="onRemove(chip)"
    >
      <span class="fa-light fa-times" aria-hidden="true"></span>
    </button>
  </span>
</template>
